// The signed-in app frame (revamp PR 3). DashboardLayout keeps every provider and guard; only the
// frame around the pages lives here. Old Mantine pages render inside it unchanged.
import '@mantine/dates/styles.css';
import type { ReactNode } from 'react';

import ImpersonationBanner from '@components/impersonation/ImpersonationBanner';
import TrialBanner from '@components/subscription/TrialBanner';
import { AppFrame } from '@/components/shell/AppFrame';
import { DashboardSidebar } from '@/components/shell/DashboardSidebar';
import { DashboardTopbar } from '@/components/shell/DashboardTopbar';

export default function DashboardContent({ children }: { children: ReactNode }) {
  return (
    <AppFrame
      sidebar={(state) => <DashboardSidebar {...state} />}
      topbar={(state) => <DashboardTopbar {...state} />}
      banners={
        <>
          <ImpersonationBanner />
          <TrialBanner />
        </>
      }
    >
      {children}
    </AppFrame>
  );
}
